import styled from "styled-components";

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 45px 8px 56px;
  background-color: #202020;
  scroll-margin-top: 40px;
`;

export const Title = styled.h4`
  font-size: 28px;
  color: white;
  text-align: center;
`;

export const SubTitleDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 8px;
`;

export const BenefitsDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  color: #ffffff;
  margin-top: 10px;
`;

export const AccordionContainer = styled.div`
  scroll-margin-top: 30px;
`;

export const Accordion = styled.div`
  position: relative;
  border: 2px solid ${({ isOpen }) => (isOpen ? "#ff8000" : "transparent")};
  width: 100%;
  background-color: #393939;
  padding: 8px;
  margin-top: 32px;
  border-radius: 6px;
  max-width: 400px;
  height: ${({ isOpen }) => (isOpen ? "auto" : "196px")};
  overflow: hidden;
  transition: height 0.3s ease;
  scroll-margin-top: 80px;

  .accordion-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 8px;
    min-height: 74px;
    gap: 4px;
  }

  img {
    max-height: 40px;
  }
`;

export const PlansDescription = styled.p`
  color: #ffffff;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  padding: 0 24px;
`;

export const PlannContainer = styled.div`
  background-color: #222222;
  width: 100%;
  padding: 12px 6px;
  margin-top: 22px;
  border-radius: 4px;
  padding-bottom: 72px;
`;

export const AnnualPlan = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 125px;
  border-radius: 4px;
  border: 2px solid ${({ checked }) => (checked ? "#ff8000" : "transparent")};
  transition: border-color 0.3s ease;
  padding: 8px;
`;

export const MonthlyPlan = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  /* height: 62px; */
  border: 2px solid ${({ checked }) => (checked ? "#ff8000" : "transparent")};
  border-radius: 4px;
  margin-top: 8px;
  transition: border-color 0.3s ease;
  padding: 24px 8px;
`;

export const CtaLink = styled.a`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: ${({ isOpen }) => (isOpen ? "20px" : "10px")};
  left: 50%;
  transform: translateX(-50%);
  background: rgb(255, 128, 0);
  background: linear-gradient(
    0deg,
    rgba(255, 128, 0, 1) 0%,
    rgba(255, 206, 0, 1) 100%
  );
  width: ${({ isOpen }) => (isOpen ? "91%" : "97%")};
  height: ${({ isOpen }) => (isOpen ? "50px" : "40px")};
  font-size: 18px;
  border-radius: 4px;

  &:hover {
    color: #000000;
    opacity: 0.8;
  }
`;

export const CtaButton = styled.button`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: ${({ isOpen }) => (isOpen ? "20px" : "10px")};
  left: 50%;
  transform: translateX(-50%);
  background: rgb(255, 128, 0);
  background: linear-gradient(
    0deg,
    rgba(255, 128, 0, 1) 0%,
    rgba(255, 206, 0, 1) 100%
  );
  width: ${({ isOpen }) => (isOpen ? "90%" : "97%")};
  height: ${({ isOpen }) => (isOpen ? "50px" : "40px")};
  font-size: 18px;
  border-radius: 4px;

  &:hover {
    color: #000000;
    opacity: 0.8;
  }
`;

export const RadioContainer = styled.label`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  margin: 0;
`;

export const HiddenRadio = styled.input`
  display: none;

  &:checked + span {
    background-color: transparent;
    border: 2px solid #ff8000;
  }

  &:checked + span::before {
    transform: scale(1);
  }
`;

export const CustomRadio = styled.span`
  position: relative;
  display: inline-block;
  width: 21px;
  height: 21px;
  border: 3px solid #727272;
  border-radius: 50%;
  background-color: transparent;
  transition: all 0.3s ease;

  &::before {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background-color: #ff8000;
    transform: scale(0);
    transition: all 0.3s ease;
  }
`;

export const PriceHeaderPlans = styled.div`
  p {
    font-size: 16px;
    color: #ffffff;
    white-space: nowrap;

    strong {
      font-size: 24px;
    }
  }
`;

export const PriceMonthly = styled.p`
  font-size: 16px;
  color: ${({ checked }) => (checked ? "#ffffff" : "#727272")};

  strong {
    font-size: 24px;

    @media (max-width: 425px) {
      font-size: 20px;
    }
  }
`;

export const PriceRadioLabel = styled.p`
  font-size: 16px;
  color: ${({ checked }) => (checked ? "#ffffff" : "#727272")};
  font-weight: ${({ checked }) => (checked ? "bold" : "normal")};
  margin-left: 8px;

  @media (max-width: 425px) {
    font-size: 14px;
  }
`;

export const Discount = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  top: 6px;
  left: 0;
  background-color: ${({ checked }) => (checked ? "#ff8000" : "#1D1D1D")};
  padding: 6px;
  border-radius: 0 99px 99px 0;
  min-width: 40%;

  p {
    color: ${({ checked }) => (checked ? "#ffffff" : "#727272")};
    font-size: 14px;
  }
`;

export const CinemaOffer = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  right: 0;
  bottom: 6px;
  background-color: ${({ checked }) => (checked ? "#6c04ba" : "#1D1D1D")};
  padding: 6px;
  border-radius: 99px 0 0 99px;

  width: 48%;

  p {
    color: ${({ checked }) => (checked ? "#ffffff" : "#727272")};
    font-size: 16px;
    line-height: 18px;
  }
`;

export const AnnualPrice = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  right: 0;
  top: ${({ hiddenReceba40 }) => (hiddenReceba40 ? "32px" : "8px")};
  background-color: transparent;
  min-width: 48%;

  p {
    color: ${({ checked }) => (checked ? "#ffffff" : "#727272")};
    font-size: 16px;
  }

  strong {
    color: ${({ checked }) => (checked ? "#ffffff" : "#727272")};
    font-size: 24px;

    @media (max-width: 425px) {
      font-size: 20px;
    }
  }

  small {
    color: ${({ checked }) => (checked ? "#ffffff" : "#727272")};
    font-size: 14px;
  }
`;

export const AccordionTitle = styled.h3`
  font-size: 20px;
  color: #ffffff;

  @media (max-width: 425px) {
    font-size: 18px;
  }
`;

export const ChannelsImgContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: #222222;
  height: 50px;
  width: 100%;
  border-radius: 6px;
  padding: 8px;
  margin-bottom: ${({ isOpen }) => (isOpen ? "18px" : "60px")};
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(1, 1, 1, 0.6);
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  display: ${({ openModal }) => (openModal ? "flex" : "none")};
`;

export const Modal = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 400px;
  background-color: #393939;
  padding: 16px;
  border: 2px solid #ff8000;
  border-radius: 6px;
`;

export const ModalClose = styled.button`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 6px;
  right: 6px;
  width: 30px;
  height: 30px;
  border-radius: 6px;
  background-color: #2f2f2f;
  font-size: 16px;
  color: #ffffff;
  font-weight: bold;
`;

export const SubTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #6c04ba;
  color: #ffffff;
  font-size: 22px;
  height: 70px;
  border-radius: 6px;
  font-size: 16px;
  margin-top: 48px;
`;

export const ImgIngresso = styled.img`
  width: 110px;
  height: 27px;
  margin: 0 10px;
`;

export const Benefits = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
`;

export const Benefit = styled.span`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

export const ImgBenefit = styled.img`
  width: 40px;
  height: 40px;
  margin-right: 10px;
`;

export const TextBenefit = styled.p`
  font-size: 14px;
  margin-top: 10px;
  text-align: left;
`;

export const TotalChannels = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    font-size: 24px;
    color: #ffffff;
    line-height: 24px;
  }

  small {
    font-size: 14px;
    color: #ffffff;
  }
`;
